// extracted by mini-css-extract-plugin
export default {"statsContainer":"offlineSites_statsContainer__qipDJ","container":"offlineSites_container__jGsTJ","searchContainer":"offlineSites_searchContainer__6XPbI"};